import { CAPABILITY_KEYS } from '../constants/capabilities';
import { hasLoadedCapabilities } from '../utils/capabilityUtils';
import { useCapability } from './useCapability';

export const getOrganizationProfileFallbackPath = (canViewProfile) => {
  return canViewProfile ? '/org-settings' : '/dashboard';
};

export const useOrganizationProfileAccess = () => {
  const capability = useCapability(CAPABILITY_KEYS.ORGANIZATION_PROFILE);
  const capabilitiesLoaded = hasLoadedCapabilities(capability.capabilities);

  return {
    canViewOrganizationProfile: capability.visible,
    canManageOrganizationProfile: capability.accessible,
    isReadOnlyOrganizationProfile: capability.isRestricted,
    capabilitiesLoaded,
    isResolved: capabilitiesLoaded,
    ...capability,
  };
};
